import { sub, unSub, VIEWPORT_SCROLL } from '../../core/utils/KGevent'
import KDevice from '../../core/utils/KDevice'
import { window } from 'ssr-window'

export default {
  name: 'KImage',
  props: {
    width: {
      type: Number,
      // required: true,
    },
    height: {
      type: Number,
      // required: true,
    },
    src: {
      type: String,
      // required: true,
    },
    retinaSrc: {
      type: String,
    },
    defaultSrc: {
      type: String,
    },
    defaultRetinaSrc: {
      type: String,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      realSrc: '',
      innerSrc: '',
      innerDefault: '',
      imgElement: '',
      showDefault: true,
    }
  },
  watch: {
    src: {
      handler(value) {
        this.innerSrc = value
        this.checkDeviceIsRetina()
        this.checkImageSrc()
      },
    },
  },
  created() {
    this.innerSrc = this.src
    if (this.defaultSrc) {
      this.innerDefault = this.defaultSrc
    } else {
      KDevice.isRetina
        ? this.innerDefault = require('./default@2x.png')
        : this.innerDefault = require('./default.png')
    }
    this.checkDeviceIsRetina()
  },
  mounted() {
    this.imgElement = this.$el.firstChild
    sub(VIEWPORT_SCROLL, this.checkImageSrc)
    setTimeout(() => {
      this.checkImageSrc()
    }, 0)
  },
  methods: {
    checkDeviceIsRetina() {
      if (KDevice.isRetina && this.retinaSrc) {
        this.innerSrc = this.retinaSrc
      }
      if (KDevice.isRetina && this.defaultRetinaSrc) {
        this.innerDefault = this.defaultRetinaSrc
      }
    },
    checkImageSrc() {
      if (this.checkElementInVisibleArea(this.imgElement)) {
        this.realSrc = this.innerSrc
      }
    },
    // element 目标元素
    // container 容器元素、不传默认为浏览器可视区域
    checkElementInVisibleArea(element, container) {
      let elementRect = element.getBoundingClientRect()
      let containerRect
      let windowRect = {
        width: window.innerWidth,
        height: window.innerHeight,
        top: 0,
        bottom: window.innerHeight,
        left: 0,
        right: window.innerWidth,
        x: 0,
        y: 0,
      }

      if (container) {
        containerRect = container.getBoundingClientRect()
        if (containerRect.left < (windowRect.left - containerRect.width) ||
          containerRect.right > (windowRect.right + containerRect.width) ||
          containerRect.top < (windowRect.top - containerRect.height) ||
          containerRect.bottom > (windowRect.bottom + containerRect.height)) {
          return false
        }
      } else {
        containerRect = windowRect
      }

      if (elementRect.left > (containerRect.left - elementRect.width) &&
        elementRect.right < (containerRect.right + elementRect.width) &&
        elementRect.top > (containerRect.top - elementRect.height) &&
        elementRect.bottom < (containerRect.bottom + elementRect.height)) {
        return true
      }

      return false
    },
  },
  render() {
    const divCss = {
      class: {
        'km-image': true,
        'is-rounded': this.rounded,
      },
    }
    const css = {
      'km-image-default': this.showDefault,
      'km-image-lazy': !this.showDefault,
    }
    const style = {
      width: this.width + 'px',
      height: this.height + 'px',
    }
    const attrs = {
      ...this.$attrs,
      'data-src': this.src,
      'retina-src': this.retinaSrc,
      'default-src': this.defaultSrc,
      'default-retina-src': this.defaultRetinaSrc,
    }
    const events = {
      error: () => {
        if (this.checkElementInVisibleArea(this.imgElement)) {
          this.realSrc = this.innerDefault
        }
        this.$emit('error')
      },
      load: (e) => {
        if (e.target.complete) {
          this.showDefault = false
          unSub(VIEWPORT_SCROLL, this.checkImageSrc)
        }
        this.$emit('load')
      },
    }
    const data = {
      style,
      attrs,
      class: css,
      on: events,
    }
    return (
      <div {...divCss} style={style}>
        <img
          {...data}
          src={this.realSrc}
        />
      </div>
    )
  },
}
